'use client';

import { useTranslations } from 'next-intl';
import {
  BUY_AGAIN_PRODUCTS_PAGE_PATH,
  VIEWALL_BUY_AGAIN_GAEVENTS
} from '../constants';
import { useBreakpoint } from '@cat-ecom/pcc-components';
import { PAGE_BREAKPOINTS } from 'constants/common';
import { getSeoUrl } from 'utils/links';
import { useParams, useRouter } from 'next/navigation';
import { CatHeading, CatButton } from 'components/blocks-components';
import { BuyAgainHeadingProps } from '../types';
import { SOURCE_HOME } from '../../../../_constants/constants';

export const BuyAgainHeading = ({
  productCount,
  showViewAll
}: Readonly<BuyAgainHeadingProps>) => {
  const t = useTranslations();
  const router = useRouter();
  const params = useParams();
  const isLG = useBreakpoint(PAGE_BREAKPOINTS.LG);
  const buttonSize = isLG ? 'md' : 'lg';

  const handleRedirectToBuyAgainPage = () => {
    const buyAgainProductsLink = getSeoUrl(
      params,
      BUY_AGAIN_PRODUCTS_PAGE_PATH,
      { source: SOURCE_HOME }
    );
    router.push(buyAgainProductsLink);
  };
  return (
    <div
      className="d-flex align-items-center justify-content-between px-0 pt-0 py-2 p-blg-3"
      data-testid="buy-again"
    >
      <CatHeading variant="title-sm">{t('HOMEPAGE_BUY_AGAIN')}</CatHeading>
      {showViewAll && (
        <CatButton
          variant="inline"
          size={buttonSize}
          onClick={handleRedirectToBuyAgainPage}
          data-track-event={VIEWALL_BUY_AGAIN_GAEVENTS.PRIMARY_CTA}
          data-track-attr-nltext={VIEWALL_BUY_AGAIN_GAEVENTS.BUTTON_EVENT_NAME}
          data-track-attr-context={VIEWALL_BUY_AGAIN_GAEVENTS.CONTEXT}
        >
          {t('VIEW_ALL')} ({productCount})
        </CatButton>
      )}
    </div>
  );
};
